enum SequoiaSource {
  MarkelStatewide = "Markel - Statewide",
  MarkelAppalachianUnderwriters = "Markel - Appalachian Underwriters",
  MarkelJohnsonAndJohnson = "Markel - Johnson and Johnson",
  GreatLakesInsuranceSEJohnsonAndJohnson = "Great Lakes Insurance SE - Johnson and Johnson",
  AmericanSummitNALICO = "American Summit - NALICO",
  TowerHillPrimeSUG = "Tower Hill Prime - SUG",
  TowerHillPrimeTCG = "Tower Hill Prime - TCG",
  CedarRemarket = "Cedar - Remarket",
}

export const sourceOptions = Object.values(SequoiaSource).map((value) => ({
  label: value,
  value,
}));

export interface SequoiaStatusesForm {
  riskId: string;
  source: SequoiaSource;
}

export const defaultValues: SequoiaStatusesForm = {
  riskId: undefined,
  source: sourceOptions[0].value,
};
